import { useState, useEffect  } from 'react'
import { useParams } from 'react-router-dom'
import { CheckCircle, ClipboardList } from 'lucide-react'
import toast from 'react-hot-toast'
import api from '../services/api'

export default function PreConsultPage() {
    const { token } = useParams()
    const [profile, setProfile] = useState({})
    const [submitting, setSubmitting] = useState(false)
    const [success, setSuccess] = useState(false)
    const [formData, setFormData] = useState({
        weight: '', height: '', goals: '', medical_history: '', digestion: '', stress_sleep: '', diet_habits: ''
    })

    // AUTO-SAVE : Restauration
    useEffect(() => {
        const formData = localStorage.getItem(`bellablue_answers_${token}`)
        if (formData) {
            try { setFormData(JSON.parse(formData)) } catch(e){}
        }
    }, [token])

    // AUTO-SAVE : Sauvegarde à chaque frappe, avec un debounce de 500ms pour éviter d'écrire à chaque caractère
    useEffect(() => {
        if (!Object.keys(formData).length) return

        const timer = setTimeout(() => {
            localStorage.setItem(
            `bellablue_answers_${token}`,
            JSON.stringify(formData)
            )
        }, 500)

        return () => clearTimeout(timer)
    }, [formData, token])


    // Récupération du profil public pour personnaliser le message
    useEffect(() => {
        api.get('/api/workspaces/public-profile').then(res => setProfile(res.data)).catch(() => {})
    }, [])


    const handleSubmit = async (e) => {
        e.preventDefault()
        setSubmitting(true)
        try {
            const payload = Object.fromEntries(Object.entries(formData).map(([k, v]) =>[k, v === '' ? null : (k==='weight'||k==='height' ? parseFloat(v): v)]))
            await api.post(`/api/appointments/form/${token}`, payload)
            setSuccess(true)
            localStorage.removeItem(`bellablue_answers_${token}`)
        } catch (error) {
            toast.error(error.response?.data?.detail || "Lien invalide ou déjà soumis.")
        } finally {
            setSubmitting(false)
        }
    }

    if (success) return (
        <div className="max-w-2xl mx-auto px-4 py-16 text-center">
            <div className="bg-white rounded-3xl p-10 shadow-xl border border-sage-100">
                <CheckCircle className="w-20 h-20 text-green-500 mx-auto mb-6" />
                <h1 className="text-3xl font-serif text-sage-800 mb-4">Merci !</h1>
                <p className="text-sage-600">Votre dossier préparatoire a bien été transmis à {profile?.admin_name || 'votre praticien'}.</p>
            </div>
        </div>
    )

    return (
        <div className="max-w-3xl mx-auto px-4 py-12 animate-in fade-in">
            <div className="text-center mb-10">
                <ClipboardList className="w-12 h-12 text-sage-600 mx-auto mb-4" />
                <h1 className="text-3xl font-serif text-sage-800">Dossier Préparatoire</h1>
                <p className="text-sage-600 mt-2">Afin de préparer au mieux notre première consultation.</p>
            </div>
            <form onSubmit={handleSubmit} className="space-y-6 bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
                <div className="grid grid-cols-2 gap-4">
                    <div><label className="block text-sm font-bold text-gray-700 mb-1">Poids (kg)</label><input type="number" step="0.1" value={formData.weight} onChange={e=>setFormData({...formData, weight: e.target.value})} className="w-full" /></div>
                    <div><label className="block text-sm font-bold text-gray-700 mb-1">Taille (cm)</label><input type="number" step="0.1" value={formData.height} onChange={e=>setFormData({...formData, height: e.target.value})} className="w-full" /></div>
                </div>
                <div><label className="block text-sm font-bold text-gray-700 mb-1">Vos objectifs</label><textarea rows="2" value={formData.goals} onChange={e=>setFormData({...formData, goals: e.target.value})} className="w-full" /></div>
                <div><label className="block text-sm font-bold text-gray-700 mb-1">Antécédents médicaux & traitements</label><textarea rows="2" value={formData.medical_history} onChange={e=>setFormData({...formData, medical_history: e.target.value})} className="w-full" /></div>
                <div><label className="block text-sm font-bold text-gray-700 mb-1">Habitudes alimentaires</label><textarea rows="2" value={formData.diet_habits} onChange={e=>setFormData({...formData, diet_habits: e.target.value})} className="w-full" /></div>
                <div><label className="block text-sm font-bold text-gray-700 mb-1">Digestion & Transit</label><textarea rows="2" value={formData.digestion} onChange={e=>setFormData({...formData, digestion: e.target.value})} className="w-full" /></div>
                <div><label className="block text-sm font-bold text-gray-700 mb-1">Sommeil, Énergie & Stress</label><textarea rows="2" value={formData.stress_sleep} onChange={e=>setFormData({...formData, stress_sleep: e.target.value})} className="w-full" /></div>
                <button type="submit" disabled={submitting} className="w-full btn btn-primary py-3">{submitting ? 'Envoi...' : 'Transmettre à ma diététicienne'}</button>
            </form>
        </div>
    )
}